<template>
    <div class="wrap">
        <listHeader :title="postData.rid > 0 ? '编辑简历' : '新增简历'"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="resume"
                active="info"
                :rid="postData.rid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="姓名"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入姓名" v-decorator="['name', {rules: [{ required: true, max: 16, message: '请输入姓名' }], initialValue: ''}]"/>
                            </a-form-item>


                            <a-form-item
                                label="手机号"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请填写手机号"
                                         v-decorator="['mobile', {rules: [{ required: true, validator: requiredMobile,  message: '请填写正确的手机号' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="身份证"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请填写身份证"
                                         v-decorator="['idcard', {rules: [{ required: false, validator: checkIdcard,  message: '请填写正确的身份证号码' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="客户经理"
                                v-bind="formItemLayout"
                            >
                                <a-select
                                    v-decorator="['mid', {required: true, rules: [{ message: '选择客户经理' }], initialValue: ''}]">>
                                    <a-select-option value="">选择招聘经理</a-select-option>
                                    <template v-for="(item, key) in config.manager">
                                        <a-select-option :key="key" :value="item[0]" v-if="item[0].charAt(0) != 'G'">
                                            {{ item[1] }}
                                        </a-select-option>
                                        <a-select-option v-else :key="key" :value="item[0]" :disabled="true">
                                            {{ item[1] }}
                                        </a-select-option>
                                    </template>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab,
    },
    data() {
        return {
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'rid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/resume/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.rid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            name: res.data.name,
                            mobile: res.data.mobile,
                            idcard: res.data.idcard,
                            mid: res.data.muid,
                        });
                    });
                } else {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            mid: this.$cookies.get('muid'),
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.rid > 0) {
                            url = '/manage/resume/edit';

                            values.rid = this.postData.rid;
                        } else {
                            url = '/manage/resume/save';
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.rid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
